export const build_examples = [
  {
    type: 'Marketplace Platform',
    description:
      'I want to build a platform where users can buy and sell various products or services easily.',
  },
  {
    type: 'Community Platform',
    description:
      'A social platform focused on connecting people with similar interests and encouraging community engagement.',
  },
  {
    type: 'Subscription-Based Platform',
    description: 'A service offering exclusive content or products through a subscription model.',
  },
  {
    type: 'Event Management Platform',
    description:
      'A platform for organizing, promoting, and managing events, allowing users to book tickets or register.',
  },
  {
    type: 'Booking Platform',
    description:
      'An application where users can book appointments, make reservations, or rent assets.',
  },
  {
    type: 'Digital Content Store',
    description:
      'A store for selling downloadable digital products like e-books, courses, music, or software.',
  },
  {
    type: 'Ad Network Platform',
    description:
      'A solution to connect advertisers with publishers, especially within specific niche markets or industries.',
  },
  {
    type: 'B2B Trading Platform',
    description:
      'A platform facilitating business-to-business transactions for wholesale or bulk purchasing.',
  },
  {
    type: 'Donation or Fundraising Platform',
    description:
      'A platform dedicated to raising funds for charities, personal causes, or social initiatives.',
  },
  {
    type: 'Learning or Educational Platform',
    description:
      'A platform for providing online educational courses, workshops, or tutoring services.',
  },
  {
    type: 'Job Board Platform',
    description:
      'A platform for posting job vacancies, allowing companies to connect with potential employees.',
  },
  {
    type: 'Service Marketplace Platform',
    description:
      'A marketplace for finding and hiring freelancers or service providers in various industries.',
  },
]
